import { render } from "./AboutUsComponent.vue?vue&type=template&id=5f76580e"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__